export * from '@devstroupe/components/fullscreen/fullscreen.component';
export * from '@devstroupe/components/fullscreen/fullscreen.types';
